import React from 'react';
import sicaiLogo from '../../assets/images/logos/logo-sicai.svg';
import laptopPhoto from '../../assets/images/photos/sicai-laptop.jpg';
import { urlSicaiInstaller } from '../../data/ConfigData';
import { useModal } from '../../context/ModalContext';
import './SicaiFamilySection.css';

const SicaiFamilySection = () => {
  const { openModal } = useModal();

  return (
    <section className="df-sicai-section" id="sicai">
      {/* Cabecera (Idéntica a la muestra, sin botón superior) */}
      <div className="df-sicai-header">
        <span className="df-sicai-header-tag">NUESTRAS SOLUCIONES</span>
        <h2 className="df-sicai-title">
          Familia <strong>SICAI</strong>: factura y administra a tu medida
        </h2>
      </div>

      {/* Tarjeta Principal: SICAI Web (Idéntica a la propuesta visual) */}
      <div className="df-sicai-featured-card">
        {/* Columna Izquierda: Información */}
        <div className="df-sicai-featured-content">
          <span className="df-sicai-web-badge">En línea · sin costo extra</span>

          <h3 className="df-sicai-featured-title">
            <span className="df-sicai-pill-badge">
              <img src={sicaiLogo} alt="SICAI" className="df-sicai-logo-in-title" />
            </span>
            <span>Web</span>
          </h3>

          <p className="df-sicai-featured-text">
            Genera cualquier tipo de comprobante fiscal sin necesidad de comprar ningún programa: facturas,
            notas de crédito, notas de cargo, recibos de honorarios, recibos de arrendamiento, nómina,
            comprobante de retenciones, complemento de pago, complemento de comercio exterior y más.
          </p>

          <p className="df-sicai-featured-text">
            Busca por fecha, nombre o RFC; envía e imprime ilimitadamente; verifica estatus, cancela y
            descarga acuses del SAT; personaliza tu comprobante con tu logotipo y color, y entra desde
            cualquier equipo y parte del mundo. Tu información siempre resguardada y segura.
          </p>

          <p className="df-sicai-featured-highlight">
            Contamos con todos los complementos publicados por el SAT.
          </p>

          <a
            href="https://www.digitalfactura.com/sicaiwebsys/#/login"
            target="_blank"
            rel="noopener noreferrer"
            className="df-sicai-btn-register"
          >
            Regístrate ahora mismo
          </a>
        </div>

        {/* Columna Derecha: Mockup ventana de navegador con foto */}
        <div className="df-sicai-window-mockup">
          <div className="df-sicai-window-bar">
            <span className="df-sicai-window-dot"></span>
            <span className="df-sicai-window-dot"></span>
            <span className="df-sicai-window-dot"></span>
            <img src={sicaiLogo} alt="SICAI" className="df-sicai-window-logo" />
          </div>
          <img
            src={laptopPhoto}
            alt="Persona trabajando en SICAI Web desde su laptop"
            className="df-sicai-window-img"
            loading="lazy"
          />
        </div>
      </div>

      {/* Subgrilla de SICAI Pro y SICAI Server */}
      <div className="df-sicai-subgrid">
        {/* SICAI Pro */}
        <div className="df-sicai-card">
          <div className="df-sicai-card-header">
            <h3 className="df-sicai-sub-title">
              <span className="df-sicai-pill-sm">
                <img src={sicaiLogo} alt="SICAI" className="df-sicai-logo-sm" />
              </span>
              <span>Pro</span>
            </h3>
            <span className="df-sicai-type-badge">Escritorio</span>
          </div>

          <p className="df-sicai-card-headline">
            Administra tu empresa y controla tu información desde tu equipo.
          </p>

          <p className="df-sicai-card-desc">
            SICAI Pro (Sistema Integral para el Control y Administración de la Información) es un software de administración de negocios y emisión de CFDI: clientes, productos, ventas, almacén, punto de venta y mucho más, con la facturación electrónica soportada por Digital Factura, PAC No. 58354, que garantiza que tus comprobantes serán totalmente válidos.
          </p>

          <div className="df-sicai-card-actions">
            <a
              href={urlSicaiInstaller}
              download="Instalador_SICAI.exe"
              className="df-btn df-btn-primary"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M12 4v11M7 10l5 5 5-5M5 20h14"></path>
              </svg>
              Descarga ahora
            </a>
            <button
              type="button"
              className="df-sicai-link-more"
              onClick={() => openModal('plans')}
            >
              Conoce más
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M5 12h14M13 6l6 6-6 6"></path>
              </svg>
            </button>
          </div>
        </div>

        {/* SICAI Server */}
        <div className="df-sicai-card">
          <div className="df-sicai-card-header">
            <h3 className="df-sicai-sub-title">
              <span className="df-sicai-pill-sm">
                <img src={sicaiLogo} alt="SICAI" className="df-sicai-logo-sm" />
              </span>
              <span>Server</span>
            </h3>
            <span className="df-sicai-type-badge">Red · sucursales</span>
          </div>

          <p className="df-sicai-card-headline">
            Administra tu empresa y maneja terminales para acceder a tu información.
          </p>

          <p className="df-sicai-card-desc">
            Todo lo que obtienes de SICAI Pro, potenciado para trabajar en redes con terminales: sucursales y usuarios trabajando a la vez, todo almacenado en tu servidor. Controla accesos y distribuye responsabilidades con tu equipo. Obtén control total.
          </p>

          <div className="df-sicai-card-actions">
            <button
              type="button"
              className="df-sicai-link-more"
              onClick={() => openModal('plans')}
            >
              Conoce más
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M5 12h14M13 6l6 6-6 6"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SicaiFamilySection;
